import "../Components/Home.css";
import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

// Service images

import person from "..//Components/Assets/Home-Header-Footer/user.png";
import settings from "..//Components/Assets/Home-Header-Footer/settings.png";
import growth from "..//Components/Assets/Home-Header-Footer/growth.png";
import growthchart from "..//Components/Assets/Home-Header-Footer/growth-chart.png";
import start from "..//Components/Assets/Home-Header-Footer/shine-star.png";
import star from "..//Components/Assets/Home-Header-Footer/star.png";
// Other assets
import tick from "../Components/Assets/Home-Header-Footer/tick.png";
import userAvatar from "../Components/Assets/Home-Header-Footer/fbcover-gradient.png";
// How it works image

import talk_demo from "../Components/Assets/Home-Header-Footer/talk&demo.png";
import easy_setup from "../Components/Assets/Home-Header-Footer/easy&setup.png";
import review from "../Components/Assets/Home-Header-Footer/review.png";
import schedule from "../Components/Assets/Home-Header-Footer/schedule&post.png";
import strategy from "../Components/Assets/Home-Header-Footer/strategy.png";
// import weeklygrowth from "../Components/Assets/Home-Header-Footer/controlling.png";
import weeklygrowth from "../Components/Assets/Home-Header-Footer/seo.png";
import refine from "../Components/Assets/Home-Header-Footer/refine.png";

// import userAvatar from "../Components/Assets/Home-Header-Footer/fbcover.png";

import fbpost1 from "../Components/Assets/home-social-media-image/fbpost.png";
import instaImg1 from "../Components/Assets/home-social-media-image/instapost.jpg";
import emailImg from "../Components/Assets/home-social-media-image/email.png";
import instaLikeIcon from "../Components/Assets/Home-Header-Footer/insta-like.png";
import instaShareIcon from "../Components/Assets/Home-Header-Footer/insta-share.png";
import fbcover_1 from "../Components/Assets/home-social-media-image/fb-cover-1.png";
import fbcover_2 from "../Components/Assets/home-social-media-image/fb-cover-2.png";
import likeIcon from "../Components/Assets/Home-Header-Footer/fb-like.png";
import shareIcon from "../Components/Assets/Home-Header-Footer/fb-share.png";
import commentIcon from "../Components/Assets/Home-Header-Footer/fb-comment.png";
/**
 * Home component that displays the main landing page
 * Features company introduction, services, statistics, and blog sections
 */
export function Home() {
  const scrollRef = useRef(null);
  const secondContainerRef = useRef(null);
  const howItWorksRef = useRef(null);
  const navigate = useNavigate();

  /**
   * Scrolls the blog section horizontally
   * @param {string} direction - 'left' or 'right'
   */

  /**
   * Navigates to the Book Demo page
   */
  const handleBookDemo = () => {
    navigate("/book-demo");
  };

  /**
   * Scrolls smoothly to the "How It Works" section
   * Stops when the div reaches the top of the viewport with manual offset adjustment
   */
  const scrollToHowItWorks = () => {
    if (howItWorksRef.current) {
      const elementPosition =
        howItWorksRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset;

      // Manual adjustment - change this number to control scroll position
      const manualOffset = -80; // Negative = scroll stops higher, Positive = scroll stops lower

      window.scrollTo({
        top: offsetPosition + manualOffset,
        behavior: "smooth",
      });
    }
  };

  // Scroll reveal: observe elements with .reveal and toggle .in-view on enter
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    if (!elements.length) return;

    const motionReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (motionReduced.matches) {
      elements.forEach((el) => el.classList.add("in-view"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Scroll-linked rise from bottom: adjust --rise-ty based on how far element is from mid viewport
  useEffect(() => {
    const rising = () => {
      const els = document.querySelectorAll(".reveal");
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const mid = vh * 0.7; // start rising around 70% from top
      els.forEach((el) => {
        const rect = el.getBoundingClientRect();
        // distance below the mid line; positive means below
        const dist = rect.top - mid;
        // clamp translate between 24px and 0px
        const ty = Math.max(0, Math.min(24, dist * 0.08));
        el.style.setProperty("--rise-ty", ty + "px");
      });
    };
    rising();
    window.addEventListener("scroll", rising, { passive: true });
    window.addEventListener("resize", rising);
    return () => {
      window.removeEventListener("scroll", rising);
      window.removeEventListener("resize", rising);
    };
  }, []);

  return (
    <div className="home">
      {/* Hero Section - Company branding and main message */}
      <div className="starting-container-wrapper">
        <div className="starting-container">
          {/* Core Slogan*/}
          <div className="company-motive-slogan-section">
            <div
              className="top-talent-badge hide-while-mobile-view"
              aria-label="Everything you need - One Simple Price"
            >
              <img className="star-icon " src={star} alt="Star Icon" />
              <span className="badge-text">
                Everything you need - One Simple Price
              </span>
            </div>
            {/* <div className="top-talent-badge">
            <img className="star-icon" src={start} alt="Star Icon" />
            <span className="badge-text">
              Everything you need - One Simple Price
            </span>
          </div> */}
            <div className="home-slogan column-reverse-deactive">
              Empowering Businesses with Smart Digital Marketing
            </div>

            {/* Company description and mission */}
            <div className="home-des">
              Hussme helps sellers and creators turn social media attention into
              real sales - with effortless digital marketing tools and AI Agents
              that work while you focus on your business.
              <br />
            </div>
            <div className="home-list-service-container">
              <ul className="home-list-service">
                <li>
                  <div className="square-tick  clr-1" alt="" />
                  Digital Content for All Your Social Media
                </li>
                <li>
                  <div className="square-tick clr-1" alt="" />
                  Email Campaigns That Drive Sales
                </li>
                <li>
                  <div className="square-tick clr-1" alt="" />
                  Easy-to-Use Client Portal
                </li>
                <li>
                  <div className="square-tick clr-1" alt="" />
                  Unlimited Revisions Until You’re Happy
                </li>
                <li>
                  <div className="square-tick clr-1" alt="" />
                  Cancel Anytime — No Commitments
                </li>
              </ul>
            </div>
            <div className="home-landing-to-scroll-down-btn-container">
              <div
                className="home-landing-to-scroll-down-btn"
                onClick={scrollToHowItWorks}
                style={{ cursor: "pointer" }}
              >
                See How it Works
              </div>
              <div className="book-demo-button" onClick={handleBookDemo} style={{ cursor: "pointer" }}>
                Book a Demo
              </div>
            </div>
          </div>{" "}
          {/* Blog Section - Showcasing recent posts and social media content */}
          <div className="scroll-section">
            <div className="scroll-content">
              {/* First set - Varied sizes for collage effect */}
              {/* Set 1 */}
              <div className="content-card-row">
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Facebook Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-1"
                    alt="Facebook Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={likeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={shareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Insta Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-1"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Set 3 */}
              <div className="content-card-row">
                {/* Insta card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-3"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Email Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Email Template</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card email-template-img-1"
                    alt="Facebook Post"
                  ></div>
                </div>
              </div>
              {/* Set 2 */}
              <div className="content-card  fbcover">
                <div className="card-header">
                  <img
                    src={userAvatar}
                    className="user-avatar"
                    alt="User Avatar"
                  />
                  <div className="user-info">
                    <h4>Facebook Cover Photo</h4>
                  </div>
                </div>
                <img
                  src={fbcover_1}
                  className="content-img-card "
                  alt="Facebook Cover"
                />
                <div className="card-footer">
                  <div className="engagement">
                    <span>
                      <img
                        src={likeIcon}
                        alt="Likes"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={commentIcon}
                        alt="Comments"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={shareIcon}
                        alt="Shares"
                        className="social-platform-icn"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* Set 4 */}
              <div className="content-card-row">
                {/* Insta Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-1"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Email Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Email Template</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card email-template-img-2"
                    alt="Facebook Post"
                  ></div>
                </div>
              </div>
              {/* Set 1 */}
              <div className="content-card-row">
                {/* Facebook Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Facebook Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-1"
                    alt="Facebook Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={likeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={shareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Instagram Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-2"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Set 2 */}
              <div className="content-card  fbcover">
                <div className="card-header">
                  <img
                    src={userAvatar}
                    className="user-avatar"
                    alt="User Avatar"
                  />
                  <div className="user-info">
                    <h4>Facebook Cover Photo</h4>
                  </div>
                </div>
                <img
                  src={fbcover_2}
                  className="content-img-card"
                  alt="Facebook Cover"
                />
                <div className="card-footer">
                  <div className="engagement">
                    <span>
                      <img
                        src={likeIcon}
                        alt="Likes"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={commentIcon}
                        alt="Comments"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={shareIcon}
                        alt="Shares"
                        className="social-platform-icn"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* ❗❗❗ Duplicate of Above Cards */}
              {/* Set 1 */}
              <div className="content-card-row">
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Facebook Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-1"
                    alt="Facebook Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={likeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={shareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Insta Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-1"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Set 3 */}
              <div className="content-card-row">
                {/* Insta card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-3"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Email Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Email Template</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card email-template-img-1"
                    alt="Facebook Post"
                  ></div>
                </div>
              </div>
              {/* Set 2 */}
              <div className="content-card  fbcover">
                <div className="card-header">
                  <img
                    src={userAvatar}
                    className="user-avatar"
                    alt="User Avatar"
                  />
                  <div className="user-info">
                    <h4>Facebook Cover Photo</h4>
                  </div>
                </div>
                <img
                  src={fbcover_1}
                  className="content-img-card "
                  alt="Facebook Cover"
                />
                <div className="card-footer">
                  <div className="engagement">
                    <span>
                      <img
                        src={likeIcon}
                        alt="Likes"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={commentIcon}
                        alt="Comments"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={shareIcon}
                        alt="Shares"
                        className="social-platform-icn"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* Set 4 */}
              <div className="content-card-row">
                {/* Insta Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-1"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Email Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Email Template</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card email-template-img-2"
                    alt="Facebook Post"
                  ></div>
                </div>
              </div>
              {/* Set 1 */}
              <div className="content-card-row">
                {/* Facebook Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Facebook Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-1"
                    alt="Facebook Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={likeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={shareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Instagram Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-2"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Set 2 */}
              <div className="content-card  fbcover">
                <div className="card-header">
                  <img
                    src={userAvatar}
                    className="user-avatar"
                    alt="User Avatar"
                  />
                  <div className="user-info">
                    <h4>Facebook Cover Photo</h4>
                  </div>
                </div>
                <img
                  src={fbcover_2}
                  className="content-img-card"
                  alt="Facebook Cover"
                />
                <div className="card-footer">
                  <div className="engagement">
                    <span>
                      <img
                        src={likeIcon}
                        alt="Likes"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={commentIcon}
                        alt="Comments"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={shareIcon}
                        alt="Shares"
                        className="social-platform-icn"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* ❗❗❗ Duplicate of Above Cards */}
              {/* Set 1 */}
              <div className="content-card-row">
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Facebook Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-1"
                    alt="Facebook Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={likeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={shareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Insta Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-1"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Set 3 */}
              <div className="content-card-row">
                {/* Insta card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-3"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Email Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Email Template</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card email-template-img-1"
                    alt="Facebook Post"
                  ></div>
                </div>
              </div>
              {/* Set 2 */}
              <div className="content-card  fbcover">
                <div className="card-header">
                  <img
                    src={userAvatar}
                    className="user-avatar"
                    alt="User Avatar"
                  />
                  <div className="user-info">
                    <h4>Facebook Cover Photo</h4>
                  </div>
                </div>
                <img
                  src={fbcover_1}
                  className="content-img-card "
                  alt="Facebook Cover"
                />
                <div className="card-footer">
                  <div className="engagement">
                    <span>
                      <img
                        src={likeIcon}
                        alt="Likes"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={commentIcon}
                        alt="Comments"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={shareIcon}
                        alt="Shares"
                        className="social-platform-icn"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* Set 4 */}
              <div className="content-card-row">
                {/* Insta Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card insta-img-post-1"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Email Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Email Template</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card email-template-img-2"
                    alt="Facebook Post"
                  ></div>
                </div>
              </div>
              {/* Set 1 */}
              <div className="content-card-row">
                {/* Facebook Card */}
                <div className="content-card  fbpost">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Facebook Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-1"
                    alt="Facebook Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={likeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={shareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* Instagram Card */}
                <div className="content-card instacard">
                  <div className="card-header">
                    <img
                      src={userAvatar}
                      className="user-avatar"
                      alt="User Avatar"
                    />
                    <div className="user-info">
                      <h4>Social Media Post</h4>
                    </div>
                  </div>
                  <div
                    className="content-img-card fb-img-post-2"
                    alt="Instagram Post"
                  ></div>
                  <div className="card-footer">
                    <div className="engagement">
                      <span>
                        <img
                          src={instaLikeIcon}
                          alt="Likes"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={commentIcon}
                          alt="Comments"
                          className="social-platform-icn"
                        />
                      </span>
                      <span>
                        <img
                          src={instaShareIcon}
                          alt="Shares"
                          className="social-platform-icn"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Set 2 */}
              <div className="content-card  fbcover">
                <div className="card-header">
                  <img
                    src={userAvatar}
                    className="user-avatar"
                    alt="User Avatar"
                  />
                  <div className="user-info">
                    <h4>Facebook Cover Photo</h4>
                  </div>
                </div>
                <img
                  src={fbcover_2}
                  className="content-img-card"
                  alt="Facebook Cover"
                />
                <div className="card-footer">
                  <div className="engagement">
                    <span>
                      <img
                        src={likeIcon}
                        alt="Likes"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={commentIcon}
                        alt="Comments"
                        className="social-platform-icn"
                      />
                    </span>
                    <span>
                      <img
                        src={shareIcon}
                        alt="Shares"
                        className="social-platform-icn"
                      />
                    </span>
                  </div>
                </div>
              </div>
              {/* ❗❗❗ Duplicate of Above Cards */}

              {/* End of set - Varied sizes for collage effect */}
            </div>
          </div>
          {/* If Mobile Responsive Active Core Slogan*/}
          <div className="column-reverse-active">
             <div
              className="top-talent-badge"
              aria-label="Everything you need - One Simple Price"
            >
              <img className="star-icon" src={star} alt="Star Icon" />
              <span className="badge-text">
                Everything you need - One Simple Price
              </span>
            </div>
            <div className=" home-slogan">
               Empowering Businesses with Smart Digital Marketing
            </div>
          </div>
        </div>
      </div>
      {/* How It Works - Cloned Design (new) */}
      <section
        ref={howItWorksRef}
        className="hiw2-section reveal fade-up"
        style={{ "--reveal-delay": "0ms" }}
      >
        <h2 className="hiw2-title">How It Works</h2>
        <p className="hiw2-subtitle">
          Get started in minutes with our streamlined process
        </p>
        <div className="hiw2-grid">
          {/* 01 */}
          <div className="hiw2-card">
            <div
              className="hiw2-card-inner reveal slide-right"
              style={{ "--reveal-delay": "0ms" }}
            >
              <div className="hiw2-card-top">
                <div className="hiw2-icon" aria-hidden="true">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-3.33 0-6 1.79-6 4v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1c0-2.21-2.67-4-6-4Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <span className="hiw2-step">01</span>
              </div>
              <h3 className="hiw2-card-title">Tell Us About Your Business</h3>
              <p className="hiw2-text">
                Share your brand details, goals, and target audience in a quick
                onboarding call.
              </p>
            </div>
          </div>

          {/* 02 */}
          <div className="hiw2-card">
            <div
              className="hiw2-card-inner reveal slide-right"
              style={{ "--reveal-delay": "150ms" }}
            >
              <div className="hiw2-card-top">
                <div className="hiw2-icon" aria-hidden="true">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8Z" fill="#fff" />
                  </svg>
                </div>
                <span className="hiw2-step">02</span>
              </div>
              <h3 className="hiw2-card-title">We Create Your Content</h3>
              <p className="hiw2-text">
                Our expert team crafts engaging posts, emails, and designs
                tailored to your brand.
              </p>
            </div>
          </div>

          {/* 03 */}
          <div className="hiw2-card">
            <div
              className="hiw2-card-inner reveal slide-right"
              style={{ "--reveal-delay": "300ms" }}
            >
              <div className="hiw2-card-top">
                <div className="hiw2-icon" aria-hidden="true">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 14-4-4 1.41-1.41L11 12.17l4.59-4.58L17 9l-6 7Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <span className="hiw2-step">03</span>
              </div>
              <h3 className="hiw2-card-title">Review & Approve</h3>
              <p className="hiw2-text">
                Check everything in your client portal and request unlimited
                revisions until it's perfect.
              </p>
            </div>
          </div>

          {/* 04 */}
          <div className="hiw2-card">
            <div
              className="hiw2-card-inner reveal slide-right"
              style={{ "--reveal-delay": "450ms" }}
            >
              <div className="hiw2-card-top">
                <div className="hiw2-icon" aria-hidden="true">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 17h2.5l3.5-7 4 8 3-6 1.5 3H21"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span className="hiw2-step">04</span>
              </div>
              <h3 className="hiw2-card-title">We Publish & Track</h3>
              <p className="hiw2-text">
                Sit back while we schedule posts and send campaigns. Watch your
                engagement grow!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Second Container */}
      {/* <div className="home-second-container" ref={secondContainerRef}>
        <div className="hsc-title-row">How It Works</div>
        <div className="hsc-row-container">
          <div className="hsc-row hsc-row-first">
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img src={talk_demo} className="hsc-content-logo-img" alt="" />
              </div>
              <div className="hsc-mini-title">Talk & Demo</div>
              <div className="hsc-content">
                We start with a friendly chat and quick demo — no pressure, just
                exploring how Hussme can fit your business.
              </div>
            </div>
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img src={easy_setup} className="hsc-content-logo-img" alt="" />
              </div>
              <div className="hsc-mini-title">Easy Setup</div>
              <div className="hsc-content">
                Once you’re ready, we create your account, set up your profile,
                and gather your brand details — logo, colors, and style
                preferences.
              </div>
            </div>
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img src={strategy} className="hsc-content-logo-img" alt="" />
              </div>
              <div className="hsc-mini-title">Plan Your Strategy</div>
              <div className="hsc-content">
                Together, we define your social media marketing strategy that
                fits your goals, audience, and budget.
              </div>
            </div>
          </div>

          <div className="hsc-row hsc-row-second">
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img src={review} className="hsc-content-logo-img" alt="" />
              </div>
              <div className="hsc-mini-title">Create & Review Content</div>
              <div className="hsc-content">
                Our team craft your social media posts and upload them to your
                portal for easy review.
              </div>
            </div>
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img src={refine} className="hsc-content-logo-img" alt="" />
              </div>
              <div className="hsc-mini-title">Refine & Approve</div>
              <div className="hsc-content">
                You share feedback — we tweak, polish, and perfect your content
                until you love it.
              </div>
            </div>
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img src={schedule} className="hsc-content-logo-img" alt="" />
              </div>
              <div className="hsc-mini-title">Schedule & Post Everywhere</div>
              <div className="hsc-content">
                Once approved, we schedule your posts across all your chosen
                social media platforms automatically.
              </div>
            </div>
            <div className="hsc-content-card">
              <div className="hsc-content-logo">
                <img
                  src={weeklygrowth}
                  className="hsc-content-logo-img"
                  alt=""
                />
              </div>
              <div className="hsc-mini-title">Weekly Growth Check-ins</div>
              <div className="hsc-content">
                We meet weekly to review your progress, share insights, and plan
                your next content goals.
              </div>
            </div>
          </div>
        </div>
        <div className="hsc-try-button-container">
          <Link to="/service">
            <div className="hsc-try-button">Try Hussme Today</div>
          </Link>
        </div>
      </div> */}

      <div
        className="social-platform-work-container reveal fade-up"
        style={{ "--reveal-delay": "200ms" }}
      >
        <div className="social-platform-title">
          Social channels we work with
        </div>
        <div className="social-platform-flex">
          {" "}
          <div className="social-platform-card">
            <div className="social-icon instagram-icon"></div>
            <span className="social-name">Instagram</span>
          </div>
          <div className="social-platform-card">
            <div className="social-icon youtube-icon"></div>
            <span className="social-name">YouTube</span>
          </div>
          <div className="social-platform-card">
            <div className="social-icon x-icon"></div>
            <span className="social-name">X</span>
          </div>
          <div className="social-platform-card">
            <div className="social-icon facebook-icon"></div>
            <span className="social-name">Facebook</span>
          </div>{" "}
          <div className="social-platform-card">
            <div className="social-icon linkedin-icon"></div>
            <span className="social-name">LinkedIn</span>
          </div>
        </div>
      </div>
      {/* Fourth Container */}
      <div
        className="after-before-container reveal fade-up"
        style={{ "--reveal-delay": "350ms" }}
      >
        <div className="after-before-title">
          Fully managed marketing services for small businesses
        </div>
        <div className="comparison-section">
          <div className="before-section">
            <div className="section-header">
              <span className="before-label">Before</span> Hussme
            </div>
            <div className="problems-list">
              <div className="problem-item">
                <div className="cross-icon">✕</div>
                <span>Unpredictable, high-cost agencies</span>
              </div>
              <div className="problem-item">
                <div className="cross-icon">✕</div>
                <span>Unreliable freelancers and poor communication</span>
              </div>
              <div className="problem-item">
                <div className="cross-icon">✕</div>
                <span>Inconsistent quality and missed deadlines</span>
              </div>
              <div className="problem-item">
                <div className="cross-icon">✕</div>
                <span>Unmanageable workloads and stress</span>
              </div>
              <div className="problem-item">
                <div className="cross-icon">✕</div>
                <span>Not enough time to focus on your business</span>
              </div>
            </div>
          </div>
          <div className="after-section">
            <div className="section-header after-header">
              <span className="after-label">After</span> Hussme
            </div>
            <div className="solutions-list">
              <div className="solution-item">
                <div className="check-icon">⚡</div>
                <span>Premium, on-brand content creation</span>
              </div>
              <div className="solution-item">
                <div className="check-icon">🔒</div>
                <span>Affordable, fixed monthly pricing</span>
              </div>
              <div className="solution-item">
                <div className="check-icon">📱</div>
                <span>Fast, reliable turnaround times</span>
              </div>
              <div className="solution-item">
                <div className="check-icon">💼</div>
                <span>Fully managed marketing services</span>
              </div>
              <div className="solution-item">
                <div className="check-icon">⚡</div>
                <span>More time to focus on growing your business</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Fifth Container */}
      <div
        className="fifth-container reveal fade-up"
        style={{ "--reveal-delay": "500ms" }}
      >
        <div className="elevate-your-process-container">
          <div className="elevate-1st-row">
            <div className="elevate-main-title">
              Elevates Your Social Media Presence
            </div>
            <div className="elevate-1st-row-button-container">
              <Link to='/service'><div style={{ cursor: "pointer" }} className="elevate-1st-row-button">Get Started </div></Link>
            </div>
          </div>
          <div className="elevate-2nd-row">
            <div className="elevate-2nd-row-img-card"></div>
            <div className="elevate-2nd-row-content-container">
              <div className="elevate-2nd-row-content-1st-half">
                <div>
                  <div className="elevate-content-half-title">
                    Consistent, On-Brand Content
                  </div>
                  <div className="elevate-content-half-text">
                    Your pages stay active with high-quality posts designed to
                    match your brand’s style, tone, and goals — no more gaps or
                    guesswork.
                  </div>{" "}
                </div>
                <div>
                  <div className="elevate-content-half-title">
                    Smarter Strategy, Better Reach
                  </div>
                  <div className="elevate-content-half-text">
                    We craft data-informed marketing plans that help you connect
                    with your audience where they already spend their time.
                  </div>
                </div>
                <div>
                  <div className="elevate-content-half-title">
                    Engaging Visuals That Stand Out
                  </div>
                  <div className="elevate-content-half-text">
                    Eye-catching graphics, videos, and stories built to stop the
                    scroll and build brand recognition.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="elevate-3rd-row">
            <div className="elevate-3rd-row-content-container">
              <div className="elevate-3rd-row-text-card">
                {" "}
                <div>
                  <div className="elevate-content-half-title">
                    AI + Human Touch
                  </div>
                  <div className="elevate-content-half-text">
                    Our smart AI tools speed up the creative process, while our
                    team adds the human spark that makes your brand feel real.
                  </div>{" "}
                </div>
                <div>
                  <div className="elevate-content-half-title">
                    Growth Without the Overwhelm
                  </div>
                  <div className="elevate-content-half-text">
                    You focus on your business — we handle the content,
                    scheduling, and optimization to keep your social media
                    growing.
                  </div>
                </div>
                <div>
                  <div className="elevate-content-half-title">
                    Ongoing Support & Insights
                  </div>
                  <div className="elevate-content-half-text">
                    Weekly consultations and performance check-ins keep you
                    informed, inspired, and always improving.
                  </div>
                </div>
              </div>
            </div>
            <div className="elevate-3rd-row-img-card"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
{
  /*End of Home Blog */
}
